import './browserGlobals';
import { WBFlex } from '@admiin-com/ds-web';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import configureAmplify from './init';

const root = createRoot(document.getElementById('root') as HTMLElement);

configureAmplify()
  .then(async () => {
    const { default: App } = await import('./app/App');
    root.render(
      <BrowserRouter>
        <Suspense fallback={<WBFlex />}>
          <App />
        </Suspense>
      </BrowserRouter>
    );
  })
  .catch((e) => console.error('Failed to initialize app', e));
